// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"56":"9c0a9c69","336":"9c0a9c69","587":"9c0a9c69","598":"9c0a9c69","804":"1885d59b","925":"9c0a9c69"}[chunkId] + ".chunk.css";
};